export default [
  {
    path: '/resources',
    name: 'resources',
    component: () => import('@/views/resources/ResourcesOverview.vue'),
    meta: {
      pageTitle: 'Resources',
      breadcrumb: [
        {
          text: 'Resources',
          active: true,
        },
      ],
    },
  },
]
